export default {"src":"/_next/static/media/vimeo.5fbb4b52.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};